import { request } from '@/utils/request'

// 授权接口
const authApi = {

  /** 检查 token 是否过期 */
  checkToken: () => request.get('checktoken', undefined, { withoutCheck: true }),

  /** 【】账号登录 */
  loginByAccount: (params: Recordable) => request.post('login', params),

  /** 【】账号登录 */
  loginCaptchaPictureSrc: '/api/admin/captcha/api',

  /** 手机号登录 */
  loginByMobile: (params: Recordable) => request.post('login/mobile', params),

  /** 重置密码 */
  resetPassword: (params: Recordable) => request.post('/admin_users/modifyPassword', params),

  /** 重置密码 */
  resetPayPassword: (params: Recordable) => request.post('payPassword/reset', params),

  /** 登出 */
  logout: () => request.get('logout'),

  /** 获取用户信息 */
  getUserInfo: () => request.get('admin_users/showinfo'),

  /** 获取手机验证码 */
  getCaptcha: (params: Recordable) => request.post('/global/captcha/mobile', params),

  /** 获取图片验证码 */
  getCaptchaPic: (params: Recordable) => request.post('/global/captcha/pic', params),

  /** 切换用户账号 */
  changeAccount: params => request.post('/changeAccount', params)
}

export { authApi }


